<template>
  <div class="nx-social-network-send-to-facebook">
    <v-toolbar flat dense color="transparent" class="mb-3 bordered">
      <v-layout justify-space-between>
        <v-toolbar-title>{{ name }}</v-toolbar-title>
        <div class="switch">
          <v-switch name="active" v-model="active" :disabled="disabled"></v-switch>
        </div>
      </v-layout>
    </v-toolbar>
    <div class="nx-form-fieldset" v-if="active">
      <nx-entity-selector
        :allow-edit-items="false"
        entity="socialNetworkAccount"
        :label="$t('message.socialNetwork.accounts')"
        :icon="icon"
        searcher
        :limit="1"
        :disabled="disabled"
        :formatedItems="accounts"
        :custom-filters="customFilters"
        v-model="accounts"
        v-bind="$attrs"
      ></nx-entity-selector>

      <v-text-field
        name="text"
        label="Texto"
        counter="280"
        maxlength="280"
        :disabled="disabled"
        v-model="text"
      ></v-text-field>
      <v-text-field
        name="url"
        label="URL"
        disabled
        :value="url"
      ></v-text-field>
      <v-toolbar flat dense color="transparent">
        <v-layout justify-space-between>
          <v-toolbar-title class="nx-heading--level-3">{{ $t('message.socialNetwork.status') }}</v-toolbar-title>
          <div class="status">
            <span v-if="status === PENDING">
              <v-icon color="warning" small>alarm</v-icon> {{ $t('message.socialNetwork.pending') }}
            </span>
            <span v-if="status === SENT"><v-icon color="success" small>done_all</v-icon> {{ date | formatDate }}</span>
            <span v-if="status === ERROR"><v-icon color="error" small>error</v-icon> {{ errorMessage }}</span>
          </div>
        </v-layout>
      </v-toolbar>
    </div>
  </div>
</template>

<script>

const status = {
  PENDING: 'pending',
  SENT: 'sent',
  ERROR: 'error',
};

export default {
  name: 'nx-social-network-send-to-twitter',
  props: {
    value: {
      type: Object,
      required: true,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      ...status,
    };
  },
  computed: {
    active: {
      get() {
        return this.value.active;
      },
      set(value) {
        this.emitChanges('active', value);
      },
    },
    text: {
      get() {
        return this.value.text;
      },
      set(value) {
        this.emitChanges('text', value);
      },
    },
    url() {
      return this.value.url;
    },
    accounts: {
      get() {
        if (Array.isArray(this.value.accounts)) {
          return this.value.accounts[0];
        }
        return this.value.accounts;
      },
      set(value) {
        if (value === null) {
          this.emitChanges('accounts', []);
        } else {
          this.emitChanges('accounts', [value]);
        }
      },
    },
    customFilters() {
      if (this.type === 'twitterAccount') {
        return {
          type: 'twitterAccount',
        };
      }
      if (this.type === 'facebookAccount') {
        return {
          type: 'facebookAccount',
        };
      }
      return {};
    },
    status() {
      return this.value.state;
    },
    date() {
      return this.value.date;
    },
    errorMessage() {
      return this.value.errorMessage;
    },
    icon() {
      if (this.type === 'twitterAccount') {
        return 'fa-twitter';
      }
      if (this.type === 'facebookAccount') {
        return 'fa-facebook';
      }
      return 'search';
    },
  },
  methods: {
    emitChanges(field, value) {
      this.$emit('input', { ...this.value, ...{ [field]: value } });
    },
  },
};
</script>
